export const getPacketTrackingUrl = (
  barcode: string | null,
  vendorCode: string,
): string | null => {
  if (!barcode) {
    return null;
  }
  if (vendorCode === 'PACKETA') {
    return `https://tracking.packeta.com/en/${barcode}`;
  }
  return null;
};
